import React from "react";
import { Outlet } from "react-router-dom";
import SuperAdminHeader from "../components/super-admin/SuperAdminHeader";
import SuperAdminSidebar from "../components/super-admin/SuperAdminSidebar";
import "bootstrap/dist/css/bootstrap.min.css";
import "../assets/styles/theme.scss";
import "../assets/styles/authenticated-layout.scss";

export default function SuperAdminLayout() {
  return (
    <div className="d-flex flex-column min-vh-100 bg-white text-dark">
      <SuperAdminHeader />
      <div className="authenticated-shell-wrap">
        <div className="authenticated-shell">
          <SuperAdminSidebar />
          <main className="authenticated-shell__main flex-grow-1">
            <Outlet />
          </main>
        </div>
      </div>
    </div>
  );
}
